import { Component, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation, HostListener } from '@angular/core';
import { setThrowInvalidWriteToSignalError } from '@angular/core/primitives/signals';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { } from 'googlemaps';
import { Observable } from 'rxjs';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { DumbPublicMember } from '../DTOs/dumb-public-member';
import { DumbPublicMemberLocation } from '../DTOs/dumb-public-member-location';
import { GetPublicMembersRequest } from '../DTOs/get-public-members-request';
import { PublicMemberSearchResults } from '../DTOs/public-member-search-results';
import { MemberInformationService } from '../member-information.service';
import { ViewMemberLocationsModalComponent } from '../modals/view-member-locations-modal.component';
import { GoogleMapsModule } from 'googlemaps'

@Component({
    selector: 'app-member-directory',
    templateUrl: './member-directory.component.html',
    providers: [UIBlockingService, NgbDropdown],
    encapsulation: ViewEncapsulation.None
})
export class MemberDirectoryComponent {
    constructor(private memberInformationService: MemberInformationService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal) {

    }

    @ViewChild('map') mapElement: any;
    map: google.maps.Map;
    markers: google.maps.Marker[] = [];
    members: DumbPublicMember[] = [];
    page: number = 1;
    itemsPerPage: number = 8;
    searchText: string = "";
    industrySearchText: string = "Any";
    finalSearchText: string = "";
    totalResults: number = 0;
    showMap: boolean = true;
    allLoaded: boolean = false;
    loading: boolean = false;
    totalPages = 0;
    initialLoad = true;
    adUrl1 = '';
    ad1Link = '';
    adUrl2 = '';
    ad2Link = '';
    blanks = [];
    industryOptions = ["Any", "Accounting", "Agriculture", "Apartments", "Architects", "Arts", "Automobile/Aviation/Marine", "Banks", "Business Services/Consultant/Coaches", "Childcare", "Construction/Contractors", "Education", "Employment/Staffing", "Engineers", "Entertainment", "Environmental Services", "Events/Meetings", "Finance", "Fitness/Wellness", "Food & Beverage", "Government", "Health Care", "Hotels", "Insurance", "Interior Design", "Landscaping/Ground Maintenance", "Law Firms/Legal Services", "Life Sciences", "Logistics/Transportation", "Manufacturing/Industrial", "Marketing/Media/Communications", "Nonprofit", "Office Equipment", "Personal Services & Care", "Pets & Veterinary", "Real Estate Services", "Restaurant/Catering", "Retail", "Security", "Software & Technology Services", "Travel/Tourism", "Utilities"]

    get currentPageNum() { return this.page };
    set currentPageNum(page: number) {
        this.page = page;
        if (!this.initialLoad)
            this.searchDirectory();
    }


    ngOnInit() {
        this.searchDirectory(true, true);
    }

    openViewLocationsModal(memberId: string) {
        let activeMember: DumbPublicMember = null;
        this.members.forEach(mem => {
            if (mem.companyId == memberId) {
                activeMember = mem;
            }
        })
        if (activeMember == null)
            return;

        const modalRef = this.modalService.open(ViewMemberLocationsModalComponent, { size: 'md' });
        modalRef.componentInstance.locations = activeMember.locations;
        modalRef.componentInstance.memberName = activeMember.memberName;
        modalRef.result.then(response => {
        })
            .catch(err => {

            }).finally();
    }

    ngAfterViewInit(): void {
        const mapProperties = {
            center: new google.maps.LatLng(39.7691, -86.1580),
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);

    }

    searchDirectoryObservable(): Observable<PublicMemberSearchResults> {
        var req = new GetPublicMembersRequest(this.itemsPerPage, this.currentPageNum - 1, this.searchText, this.industrySearchText);
        return this.memberInformationService
            .searchMemberDirectory(req);
    }

    searchDirectory(clearResults = false, blockUI = true) {
        if (blockUI)
            this.blockUI.start();
        if (clearResults)
            this.page = 1;
        this.loading = true;
        this.searchDirectoryObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.initialLoad = false;
                        this.totalPages = Math.floor(data.totalResults / this.itemsPerPage);
                        this.members = [];
                        this.markers.forEach(mark => {
                            mark.setMap(null);
                        });
                        this.markers = [];
                        this.allLoaded = false;
                        this.finalSearchText = this.searchText;
                        this.members = this.members.concat(data.members);
                        if (data.members.length == 0)
                            this.allLoaded = true;
                        this.totalResults = data.totalResults;
                        data.members.forEach(mem => {
                            this.addPinsToMap(mem, mem.locations);
                        });
                        
                        this.adUrl1 = data.ad1Url;
                        this.ad1Link = data.ad1Link;
                        this.adUrl2 = data.ad2Url;
                        this.ad2Link = data.ad2Link;

                        this.loading = false;
                        this.blanks = Array(8 - data.members.length).fill(0);
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        if (blockUI)
                            this.blockUI.stop();
                        this.loading = false;
                        console.log(err)
                    },
                    complete: () => {
                        if (blockUI)
                            this.blockUI.stop();
                    }
                });
    }

    nextPage() {
        if (this.page >= this.totalPages)
            return;
        this.page++;
        this.searchDirectory(false, true)
    }
    prevPage() {
        if (this.page <= 0)
            return;
        this.page--;
        this.searchDirectory(false, true)
    }
    goToPage(page: number) {
        if (this.page == page)
            return;
        this.page = page;
        this.searchDirectory(false, true)
    }
    // scrollHandler(event: any) {
    //   if (this.allLoaded)
    //     return;
    //   if (this.loading)
    //     return;

    //   var insightsResults = document.getElementsByClassName(
    //     'directoryContainer'
    //   )[0];
    //   var scrollLeft = Math.abs(insightsResults?.scrollHeight - insightsResults?.clientHeight - insightsResults?.scrollTop)
    //   var quarterTotal = insightsResults?.scrollHeight / 4;
    //   if (scrollLeft <= quarterTotal) {
    //     this.page++;
    //     this.searchDirectory(false, false);
    //   }
    // }


    addPinsToMap(member: DumbPublicMember, locs: DumbPublicMemberLocation[]) {
        locs.forEach(loc => {
            var newMark = new google.maps.Marker({
                position: new google.maps.LatLng(loc.lat, loc.long),
                map: this.map,
                title: member.companyId,
                icon: './assets/images/location-dot.png',
                clickable: true,

            })

            newMark.addListener('click', () => {
                this.openViewLocationsModal(member.companyId);
            })

            this.markers.push(newMark);
        });
    }

}
